import axios from 'axios';

class MitUserManagementService {
  constructor() {}

  passwordResetFromLink(newPassword, newPasswordConfirm, token, challengeAnswer) {
    return new Promise ((resolve, reject) => {
      if(newPassword !== newPasswordConfirm){
        return reject('New passwords do not match!');
      }
      let postData = {
        newPassword: newPassword,
        token: token,
        challengeAnswer: challengeAnswer
      };

      axios.post('/api/v1/management/user/password/reset/handler',postData)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  requestPasswordReset(userName) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/management/user/password/reset/request',{
          userName: userName
        })
        .then((response) => {
            return resolve(response.data.link);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  requestPasswordResetByAdmin(userName, pin, expireTime){
      return new Promise ((resolve, reject) => {

        axios.post('/api/v1/management/user/admin/password/reset/request',{
            userName: userName,
            pin: pin,
            expireTime: expireTime+'m'
          })
          .then((response) => {
              return resolve(response.data.link);
          })
          .catch((error) => {
            return reject(error.response.data);
          });

      });
  }

  generateResetLink(userName, pin, expireTime) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/management/user/admin/password/reset/link',{
          userName: userName,
          pin: pin,
          expireTime: expireTime+'m'
        })
        .then((response) => {
            return resolve(response.data.link);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  changePassword(userName, existingPassword, newPassword, newPasswordConfirm) {
    return new Promise ((resolve, reject) => {

      if(newPassword !== newPasswordConfirm){
        return reject('New passwords do not match!');
      }

      axios.post('/api/v1/management/user/password/change', {
          userName: userName,
          existingPassword: existingPassword,
          newPassword:newPassword
        })
        .then((response) => {
            let result = response.data;
            return resolve(result);
        })
        .catch((error) => {
          let message = error.response.data;
          if(typeof error.response.data != 'string'){
            message = 'Unknown server error';
          }
          return reject(message);
        });

    });
  }

  getPasswordValidation() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/user/password/validation')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

}

export default new MitUserManagementService();
